'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.RP = exports.PS = exports.VS = exports.IR = exports.OSTATNI = exports.P = exports.ID = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Typ dokladu.
 */

/**
 * Občanský průkaz.
 */
var ID = exports.ID = 'ID';

/**
 * Cestovní doklad.
 */
var P = exports.P = 'P';

/**
 * Ostatní.
 */
var OSTATNI = exports.OSTATNI = 'OSTATNI';

/**
 * Povolení k pobytu.
 */
var IR = exports.IR = 'IR';

/**
 * Vízový štítek.
 */
var VS = exports.VS = 'VS';

/**
 * Pobytový štítek.
 */
var PS = exports.PS = 'PS';

/**
 * Řidičský průkaz.
 */
var RP = exports.RP = 'RP';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ID, P, OSTATNI, IR, VS, PS, RP];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ID, { caption: 'Občanský průkaz.' }), (0, _defineProperty3.default)(_params, P, { caption: 'Cestovní doklad.' }), (0, _defineProperty3.default)(_params, OSTATNI, { caption: 'Ostatní.' }), (0, _defineProperty3.default)(_params, IR, { caption: 'Povolení k pobytu.' }), (0, _defineProperty3.default)(_params, VS, { caption: 'Vízový štítek.' }), (0, _defineProperty3.default)(_params, PS, { caption: 'Pobytový štítek.' }), (0, _defineProperty3.default)(_params, RP, { caption: 'Řidičský průkaz.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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